import moment from 'moment'
// import moment from 'moment-timezone'
export default {
  aTime: (val, format = 'DD.MM.YYYY') => {
    if (!val) {
      return '/'
    }
    let m
    let date = val.date || val

    if (date.charAt(date.length - 1) !== 'Z') {
      let offset = new Date().getTimezoneOffset()
      m = moment(date).subtract(offset, 'minutes')
    } else {
      m = moment(val)
    }
    if (format === 'from') {
      return m.fromNow()
    } else {
      return m.format(format)
    }
  },
  get: (val, prop, fallback = '') => {
    return val && val[prop] ? val[prop] : fallback
  }
//  punyEncode: (val) => {
//    return punycode.encode(val)
//  },
//  punyDecode: (val) => {
//    return punycode.decode(val)
//  }
}



// WEBPACK FOOTER //
// ./src/Filters.js